import { toDssPath } from '../../../migrated-routes';

const CONTA_MANAGEMENT_PATH = '/conta/manage-conta';

/**
 * Na tela de cadastro/edição de conta, sessionStorage['tenant'] guarda a conta em
 * edição — o Angular a grava para endereçar as chamadas da própria tela —, e não uma
 * conta ativa: a tela limpa o tenant ao abrir. O menu ali deve ser o do integrador
 * sem conta, como no legado, que não remontava o menu enquanto a tela estava aberta.
 */
export function isContaManagementRoute(route: string): boolean {
  const pathname = route.split('?')[0].replace(/\/+$/, '');
  return pathname === CONTA_MANAGEMENT_PATH || pathname === toDssPath(CONTA_MANAGEMENT_PATH);
}
